import { ofType } from 'redux-observable'
import { catchError, map, mergeMap, of } from 'rxjs'
import {
  actionTypes,
  techUserCreateFailureAction,
  techUserCreateSuccessAction,
  techUserDeleteFailureAction,
  techUserDeleteSuccessAction,
  techUserUpdateFailureAction,
  techUserUpdateSuccessAction,
  techUsersBlockAccountActionFailure,
  techUsersBlockAccountActionSuccess,
  techUsersChangePwdAccountActionFailure,
  techUsersChangePwdAccountActionSuccess,
  techUsersChangePwdVerifyCaMobileOtpActionFailure,
  techUsersChangePwdVerifyCaMobileOtpActionSuccess,
  techUsersChangePwdVerifySecQuestsActionFailure,
  techUsersChangePwdVerifySecQuestsActionSuccess,
  techUsersChangePwdVerifyUigpOtpActionFailure,
  techUsersChangePwdVerifyUigpOtpActionSuccess,
  techUsersGetApplicationsActionFailure,
  techUsersGetApplicationsActionSuccess,
  techUsersGetCatalogEntitlementsActionFailure,
  techUsersGetCatalogEntitlementsActionSuccess,
  techUsersGetOusActionFailure,
  techUsersGetOusActionSuccess,
  techUsersGetPwdPolicyActionFailure,
  techUsersGetPwdPolicyActionSuccess,
  techUsersGetTechnicalUserActionFailure,
  techUsersGetTechnicalUserActionSuccess,
  techUsersGetTechnicalUserEntitlementsActionFailure,
  techUsersGetTechnicalUserEntitlementsActionSuccess,
  techUsersResetPwdAccountActionFailure,
  techUsersResetPwdAccountActionSuccess,
  techUsersResetPwdVerifyCaMobileOtpActionFailure,
  techUsersResetPwdVerifyCaMobileOtpActionSuccess,
  techUsersResetPwdVerifySecQuestsActionFailure,
  techUsersResetPwdVerifySecQuestsActionSuccess,
  techUsersResetPwdVerifyUigpOtpActionFailure,
  techUsersResetPwdVerifyUigpOtpActionSuccess,
  techUsersUnlockAccountActionFailure,
  techUsersUnlockAccountActionSuccess,
} from './actions'
import { ouForTechnicalUserService } from '../../../service/ouService'
import { techUsersEntitlementsByOuIdService } from '../../../service/entitlementService'
import { applicationsByOuIdService } from '../../../service/applicationsService'
import {
  technicalUsersBlockAccountService,
  technicalUsersByOuIdService,
  technicalUsersChangePwdService,
  technicalUsersCreateService,
  technicalUsersDeleteService,
  technicalUsersEntitlementsService,
  technicalUsersPasswordPolicyService,
  technicalUsersResetPwdService,
  technicalUsersUnlockAccountService,
  technicalUsersUpdateService,
  technicalUsersResetPwdVerifyCaMobileOtpService,
  technicalUsersResetPwdVerifySecQuestsService,
  technicalUsersResetPwdVerifyUigpOtpService,
  technicalUsersChangePwdVerifyUigpOtpService,
  technicalUsersChangePwdVerifySecQuestsService,
  technicalUsersChangePwdVerifyCaMobileOtpService,
} from '../../../service/technicalUserService'
import {
  saveTechnicalUser,
  technicalGetUserType,
  technicalUsersListService,
} from './apiService'

const fetchUserOusEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_GET_OU),
    mergeMap(() =>
      technicalGetUserType().pipe(
        map((response: any) => techUsersGetOusActionSuccess(response)),
        catchError((error: any) => of(techUsersGetOusActionFailure(error)))
      )
    )
  )

const fetchTechnicalUsersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_GET_TU),
    mergeMap((action: any) =>
      technicalUsersListService(action.payload).pipe(
        map((response: any) =>
          techUsersGetTechnicalUserActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersGetTechnicalUserActionFailure(error))
        )
      )
    )
  )

const fetchApplicationsForSelectEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_GET_APPLICATIONS),
    mergeMap((action: any) =>
      applicationsByOuIdService(action.payload).pipe(
        map((response: any) => techUsersGetApplicationsActionSuccess(response)),
        catchError((error: any) =>
          of(techUsersGetApplicationsActionFailure(error))
        )
      )
    )
  )

const fetchCatalogEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_GET_CATALOG_ENTITLEMENTS),
    mergeMap((action: any) =>
      techUsersEntitlementsByOuIdService(action.payload).pipe(
        map((response: any) =>
          techUsersGetCatalogEntitlementsActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersGetCatalogEntitlementsActionFailure(error))
        )
      )
    )
  )

const fetchTechnicalUserEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_GET_TU_ENTITLEMENTS),
    mergeMap((action: any) =>
      technicalUsersEntitlementsService(action.payload).pipe(
        map((response: any) =>
          techUsersGetTechnicalUserEntitlementsActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersGetTechnicalUserEntitlementsActionFailure(error))
        )
      )
    )
  )

const createTechnicalUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_CREATE),
    mergeMap((action: any) =>
      saveTechnicalUser(action.payload).pipe(
        map((response: any) => techUserCreateSuccessAction(response)),
        catchError((error: any) => of(techUserCreateFailureAction(error)))
      )
    )
  )

// ---------------------------------------------------------
const updateTechnicalUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_UPDATE),
    mergeMap((action: any) =>
      technicalUsersUpdateService(action.payload).pipe(
        map((response: any) => techUserUpdateSuccessAction(response)),
        catchError((error: any) => of(techUserUpdateFailureAction(error)))
      )
    )
  )

const deleteTechnicalUserEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_DELETE),
    mergeMap((action: any) =>
      technicalUsersDeleteService(action.payload).pipe(
        map((response: any) => techUserDeleteSuccessAction(response)),
        catchError((error: any) => of(techUserDeleteFailureAction(error)))
      )
    )
  )

const technicalUserResetPwdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_RESET_PWD),
    mergeMap((action: any) =>
      technicalUsersResetPwdService(action.payload).pipe(
        map((response: any) => techUsersResetPwdAccountActionSuccess(response)),
        catchError((error: any) =>
          of(techUsersResetPwdAccountActionFailure(error))
        )
      )
    )
  )

const technicalUserChangePwdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_CHANGE_PWD),
    mergeMap((action: any) =>
      technicalUsersChangePwdService(action.payload).pipe(
        map((response: any) =>
          techUsersChangePwdAccountActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersChangePwdAccountActionFailure(error))
        )
      )
    )
  )

const technicalUserUnlockAccountEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_UNLOCK_ACCOUNT),
    mergeMap((action: any) =>
      technicalUsersUnlockAccountService(action.payload).pipe(
        map((response: any) => techUsersUnlockAccountActionSuccess(response)),
        catchError((error: any) =>
          of(techUsersUnlockAccountActionFailure(error))
        )
      )
    )
  )

const technicalUserBlockAccountEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_BLOCK_ACCOUNT),
    mergeMap((action: any) =>
      technicalUsersBlockAccountService(action.payload).pipe(
        map((response: any) => techUsersBlockAccountActionSuccess(response)),
        catchError((error: any) =>
          of(techUsersBlockAccountActionFailure(error))
        )
      )
    )
  )

const technicalUserPwdPolicyEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_GET_PWD_POLICY),
    mergeMap((action: any) =>
      technicalUsersPasswordPolicyService(action.payload).pipe(
        map((response: any) => techUsersGetPwdPolicyActionSuccess(response)),
        catchError((error: any) =>
          of(techUsersGetPwdPolicyActionFailure(error))
        )
      )
    )
  )

const technicalUserResetPwdVerifyCaMobileOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_RESET_PWD_VERIFY_CA_MOBILE_OTP),
    mergeMap((action: any) =>
      technicalUsersResetPwdVerifyCaMobileOtpService(action.payload).pipe(
        map((response: any) =>
          techUsersResetPwdVerifyCaMobileOtpActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersResetPwdVerifyCaMobileOtpActionFailure(error))
        )
      )
    )
  )

const technicalUserResetPwdVerifySecQuestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_RESET_PWD_VERIFY_SEC_QUESTS),
    mergeMap((action: any) =>
      technicalUsersResetPwdVerifySecQuestsService(action.payload).pipe(
        map((response: any) =>
          techUsersResetPwdVerifySecQuestsActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersResetPwdVerifySecQuestsActionFailure(error))
        )
      )
    )
  )

const technicalUserResetPwdVerifyUigpOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_RESET_PWD_VERIFY_UIGP_OTP),
    mergeMap((action: any) =>
      technicalUsersResetPwdVerifyUigpOtpService(action.payload).pipe(
        map((response: any) =>
          techUsersResetPwdVerifyUigpOtpActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersResetPwdVerifyUigpOtpActionFailure(error))
        )
      )
    )
  )

const technicalUserChangePwdVerifyCaMobileOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_CHANGE_PWD_VERIFY_CA_MOBILE_OTP),
    mergeMap((action: any) =>
      technicalUsersChangePwdVerifyCaMobileOtpService(action.payload).pipe(
        map((response: any) =>
          techUsersChangePwdVerifyCaMobileOtpActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersChangePwdVerifyCaMobileOtpActionFailure(error))
        )
      )
    )
  )

const technicalUserChangePwdVerifySecQuestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_CHANGE_PWD_VERIFY_SEC_QUESTS),
    mergeMap((action: any) =>
      technicalUsersChangePwdVerifySecQuestsService(action.payload).pipe(
        map((response: any) =>
          techUsersChangePwdVerifySecQuestsActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersChangePwdVerifySecQuestsActionFailure(error))
        )
      )
    )
  )

const technicalUserChangePwdVerifyUigpOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECH_USER_CHANGE_PWD_VERIFY_UIGP_OTP),
    mergeMap((action: any) =>
      technicalUsersChangePwdVerifyUigpOtpService(action.payload).pipe(
        map((response: any) =>
          techUsersChangePwdVerifyUigpOtpActionSuccess(response)
        ),
        catchError((error: any) =>
          of(techUsersChangePwdVerifyUigpOtpActionFailure(error))
        )
      )
    )
  )

const epics = [
  fetchUserOusEpic,
  fetchTechnicalUsersEpic,
  fetchCatalogEntitlementsEpic,
  fetchApplicationsForSelectEpic,
  fetchTechnicalUserEntitlementsEpic,
  createTechnicalUserEpic,
  updateTechnicalUserEpic,
  deleteTechnicalUserEpic,
  technicalUserResetPwdEpic,
  technicalUserChangePwdEpic,
  technicalUserPwdPolicyEpic,
  technicalUserBlockAccountEpic,
  technicalUserUnlockAccountEpic,
  technicalUserResetPwdVerifyCaMobileOtpEpic,
  technicalUserResetPwdVerifySecQuestsEpic,
  technicalUserResetPwdVerifyUigpOtpEpic,
  technicalUserChangePwdVerifyCaMobileOtpEpic,
  technicalUserChangePwdVerifySecQuestsEpic,
  technicalUserChangePwdVerifyUigpOtpEpic,
]

export default epics
